import BackofficeInterceptor from '../BackofficeInterceptor'

const api = new BackofficeInterceptor()

export default {
  getOperadora(){
    return api.get(`/operadora`)
  },

  getOperadoraById(id){
    return api.get(`/operadora/${encodeURI(id)}`)
  },

  getOperadoraDetailById(id){
    return api.get(`/operadora/detalhe/${encodeURI(id)}`)
  },

  getOperadoraByLocation(idLocation) {
    return api.get(`/operadora/localidade/${encodeURI(idLocation)}`)
  },
}
